import {css} from "@emotion/react";
import {
  DatePicker,
  Text,
  DropdownSelectList,
  DropdownSelectOption,
  styled,
} from "@reside/ui";
import {Tooltip} from "../tooltip";

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-bottom: 0.625em;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const ClickOutsideWrapper = styled.div``;

export const Label = styled.label<
  Readonly<{disabled?: boolean; isOpened: boolean}>
>`
  display: flex;
  cursor: pointer;
  width: 100%;
  align-items: center;
  padding: 4px 6px;

  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
  }

  ${({disabled, theme}) =>
    disabled
      ? css`
          cursor: not-allowed;
        `
      : css`
          &:hover {
            background: ${theme.color.lightBlue10};
          }
        `};

  ${({isOpened, theme}) =>
    isOpened &&
    css`
      background: ${theme.color.lightBlue10};
    `};

  /* Status dropdown caret + optional checklist date: hidden until hover/focus; always visible on touch. */
  [data-task-status-caret],
  [data-checklist-item-date-hover] {
    opacity: 1;
    transition: opacity 0.12s ease;
  }

  @media (hover: hover) and (pointer: fine) {
    [data-task-status-caret],
    [data-checklist-item-date-hover] {
      opacity: 0;
    }

    &[data-status-dropdown-open="true"] [data-task-status-caret],
    &[data-status-dropdown-open="true"] [data-checklist-item-date-hover] {
      opacity: 1;
    }

    ${({disabled, isOpened}) =>
      disabled
        ? css`
            [data-task-status-caret],
            [data-checklist-item-date-hover] {
              opacity: 0 !important;
            }
          `
        : css`
            &:hover [data-task-status-caret],
            &:hover [data-checklist-item-date-hover],
            &:focus-within [data-task-status-caret],
            &:focus-within [data-checklist-item-date-hover] {
              opacity: 1;
            }

            ${isOpened &&
            css`
              [data-task-status-caret],
              [data-checklist-item-date-hover] {
                opacity: 1;
              }
            `}
          `}
  }
`;

export const LabelText = styled(Text)<{strikeThrough: boolean}>`
  font-size: 1.25em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;

  ${({strikeThrough, theme}) =>
    strikeThrough &&
    css`
      text-decoration: line-through;
      color: ${theme.color.darkBlue70};
    `};
`;

export const StyledDatePicker = styled(DatePicker)`
  z-index: 1000;
`;

export const FormattedDate = styled.time<{disabled: boolean}>`
  white-space: nowrap;
  margin-left: auto;

  ${({disabled}) =>
    disabled &&
    css`
      cursor: not-allowed;
    `};
`;

export const StyledTooltip = styled(Tooltip)<{
  disabled: boolean;
}>`
  overflow: hidden;
  display: flex;
  align-items: center;

  ${({disabled}) =>
    disabled &&
    css`
      cursor: not-allowed;
    `};
`;

export const StyledDropdownSelectList = styled(DropdownSelectList)`
  margin-top: 0;
`;

export const StyledDropdownSelectOption = styled(DropdownSelectOption)`
  position: relative;
  padding: 8px 12px 8px 40px;

  .icon {
    position: absolute;
    left: 0;
    top: 0;
    width: 38px;
    line-height: 33px;
    display: inline-block;
    text-align: center;
  }
`;
